import { Grid, Stack, Typography } from '@mui/material';

export default function CourseInfoItem({ id, label, value }) {
  return (
    <Grid id={`${id}__grid_container`} container spacing={{ xs: 0, sm: 1 }}>
      <Grid item id={`${id}__grid_item_label`} textAlign={'start'} xs={12} md={3} lg={4} xl={3}>
        <Typography id={`${id}__text_label`} className="myOdu__label" component="label">
          {label}
        </Typography>
      </Grid>
      <Grid item id={`${id}__grid_item_value`} textAlign={'start'}>
        <Typography id={`${id}__text_value`}>{value}</Typography>
      </Grid>
    </Grid>
  );
}
